import { React, useState, useMemo, useEffect } from "react";
import { showLoader, dispatchToStore } from "@cisco/spaces-dash-lib-redux-store";
// import { Flex, MSpinner } from "@cisco/spaces-dash-lib-styleguide";
import { LoadingContext } from "../contexts/loadingContext";

export default function (props) {
  const [loading, setLoading] = useState(false);
  const { children } = props;
  const contextValue = useMemo(() => ({ loading, setLoading }), [loading, setLoading]);

  useEffect(() => {
    if (loading) {
      dispatchToStore(showLoader({ flag: true, loadingRef: "hierarchy" }));
    } else {
      dispatchToStore(showLoader({ flag: false, loadingRef: "hierarchy" }));
    }
  }, [loading]);

  return (
    <LoadingContext.Provider value={contextValue}>
      {children}
      {/* {loading && (
        <Flex
          justify="center"
          align="center"
          // style={{
          //   position: "fixed",
          //   top: 0,
          //   bottom: 0,
          //   left: 0,
          //   zIndex: 99999999,
          //   overflow: "hidden",
          //   width: "100%",
          //   background: "rgba(0,0,0,0.4)"
          // }}
          data-testid="lh20-full-screen-loader"
        >
          <MSpinner size="md" />
        </Flex>
      )} */}
    </LoadingContext.Provider>
  );
}
